import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

export default createUseStyles<string, { img: string }>(
  {
    wrapper: {
      paddingLeft: Spacings.s24,
      '@media screen and (max-width: 425px)': {
        padding: 0,
      },
    },
    imgContainer: {
      borderRadius: CornerRadius.r8,
      cursor: 'pointer',
      display: 'block',
      height: 224,
      marginBlock: Spacings.s16,
      overflow: 'hidden',
      position: 'relative',
      transition: 'all 0.15s ease-out',

      '& > div': {
        height: '100%',
      },

      '&:hover': {
        '& $btnContainer': {
          display: 'flex',
        },
      },
    },

    btnContainer: {
      display: 'none',
      alignItems: 'center',
      top: 0,
      left: 0,
      height: 72,
      justifyContent: 'center',
      position: 'absolute',
      width: '100%',
      transition: 'all 0.15s ease-out',

      '& div': {
        backgroundImage: 'unset',
      },
    },

    img: {
      objectFit: 'cover',
      maxWidth: 448,
      minWidth: 122,
      height: '100%',
    },

    editButton: {
      minWidth: 116,
    },

    badge: {
      position: 'absolute',
      left: Spacings.s8,
      top: Spacings.s8,
    },
  },
  { name: 'Template' },
);
